import { useSelector } from 'react-redux'
import CreateJob from './CreateJob'
import JobArchived from './JobArchived'
import JobCandidate from './JobCandidate'
import JobOnboarding from './JobOnboarding'
import JobScreening from './JobScreening'
import JobsManagement from './JobsManagement'
import SystemSetup from './System Setup'
import AreYouSureModal from './AreYouSureModal'
import AlertModal from './AlertModal'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useDispatch } from 'react-redux'
import { setFormSubmitted } from 'store/Recruitment/actions'
import JobDetails from './JobDetails'
import JobApplications from './JobApplications'
import ApplicationDetails from './JobDetails/ApplicationDetails/ApplicationDetails'
import InterviewSchedule from './InterviewSchedule/CalendarView'
import Career from './Career'
import { ToastContainer } from 'react-toastify'
import AIInterview from './AiInterview/AIInterview'
import AIInterviewTest from './AiInterview/AIInterviewTest'

function Recruitment() {
  const dispatch = useDispatch()

  const location = useLocation()

  useEffect(() => {
    dispatch(setFormSubmitted(false))
  }, [location.pathname, dispatch])

  return (
    <>
      <div className='m-4'>
        {window.location.pathname === '/jobs' && <JobsManagement />}
        {window.location.pathname === '/job/create' && <CreateJob />}
        {window.location.pathname === '/job/edit' && <CreateJob />}
        {window.location.pathname === '/job/details' && <JobDetails />}
        {window.location.pathname === '/job/system-setup' && <SystemSetup />}
        {window.location.pathname === '/job-application' && <JobApplications />}
        {window.location.pathname === '/job/application/details' && (
          <ApplicationDetails />
        )}
        {window.location.pathname === '/job-screening' && <JobScreening />}
        {window.location.pathname === '/job-onboard' && <JobOnboarding />}
        {window.location.pathname === '/job-candidates' && <JobCandidate />}
        {window.location.pathname === '/job-archived' && <JobArchived />}
        {window.location.pathname === '/job/interview-schedule' && (
          <InterviewSchedule />
        )}
        {window.location.pathname === '/job/career' && <Career />}
        {window.location.pathname === '/job/ai-interview' && (
          <AIInterviewTest applicationId={52} interviewId={40} />
        )}
      </div>

      <ToastContainer />
    </>
  )
}

export default Recruitment
